module.exports = __webpack_public_path__ + "static/shuttleid-award-winners-c1cf4304c14cc260fe0cd0f5f837eef2.jpg";